import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8decbea2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "content-back"
};
const _hoisted_4 = {
  class: "head-menu"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "line-main"
};
const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-min"
}, "有福同享  多邀多得", -1));

const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "word-main"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "item-back"
};
const _hoisted_14 = ["src"];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "rule-title"
}, "邀请记录", -1));

const _hoisted_16 = {
  class: "share-back"
};
const _hoisted_17 = {
  class: "inv-count-main"
};
const _hoisted_18 = {
  class: "inv-count-back"
};
const _hoisted_19 = {
  class: "big-price"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("人 ");

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inv-desc-text"
}, "累计邀请", -1));

const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "inv-count-back"
};
const _hoisted_24 = {
  class: "big-price"
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode("天会员 ");

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inv-desc-text"
}, "已获得奖励", -1));

const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "btn-back"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分享链接", -1));

const _hoisted_30 = [_hoisted_29];

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分享海报", -1));

const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  key: 0,
  class: "tips-hide"
};
const _hoisted_34 = {
  key: 1,
  class: "tips-back"
};
const _hoisted_35 = {
  class: "tips-main"
};
const _hoisted_36 = ["src"];

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "rule-title"
}, "规则说明", -1));

const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 1、好友通过你分享的链接或二维码注册后，将自动绑定邀请关系");

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 2、邀请男性首次开通会员，将获得会员时长奖励");

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 3、仅邀请新用户有奖励，邀请已经注册的用户无法获得奖励");

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 4、禁止以任何形式刷奖励，相同设备和IP视为同一用户，不能通过邀请自己的方式获取返利");

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 5、邀请好友，代表你已阅读并同意代表您已经同意");

const _hoisted_47 = /*#__PURE__*/_createTextVNode("《分享协议》");

const _hoisted_48 = /*#__PURE__*/_createTextVNode("和");

const _hoisted_49 = /*#__PURE__*/_createTextVNode("《分享推广规范》");

const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 6、小圈约官方拥有最终解释权 ");

const _hoisted_52 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.InvBack,
    class: "back-head"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.Back,
    class: "back-icon",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.back && $setup.back(...args))
  }, null, 8, _hoisted_5), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.showTips && $setup.showTips(...args)),
    class: "rule-word"
  }, "活动规则")])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $setup.LineLeft,
    class: "line"
  }, null, 8, _hoisted_7), _hoisted_8, _createElementVNode("img", {
    src: $setup.LineRight,
    class: "line"
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $setup.Word,
    class: "big-word"
  }, null, 8, _hoisted_11)]), _createElementVNode("img", {
    src: $setup.MidImg,
    class: "mid-img"
  }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
    src: $setup.TipsTop,
    class: "tips-top"
  }, null, 8, _hoisted_14), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_19, _toDisplayString($setup.info.count), 1), _hoisted_20]), _createElementVNode("div", {
    class: "inv-desc",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.push({
      name: 'InviteRecord'
    }))
  }, [_hoisted_21, _createElementVNode("img", {
    src: $setup.More,
    class: "more-icon"
  }, null, 8, _hoisted_22)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_24, _toDisplayString($setup.info.day), 1), _hoisted_25]), _createElementVNode("div", {
    class: "inv-desc",
    onClick: _cache[3] || (_cache[3] = $event => $setup.router.push({
      name: 'InviteRecord'
    }))
  }, [_hoisted_26, _createElementVNode("img", {
    src: $setup.More,
    class: "more-icon"
  }, null, 8, _hoisted_27)])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    class: "share-btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.link && $setup.link(...args))
  }, _hoisted_30), _createElementVNode("div", {
    class: "share-btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.haibao && $setup.haibao(...args))
  }, _hoisted_32)])])]), $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_33)) : _createCommentVNode("", true), $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
    src: $setup.TipsTop,
    class: "tips-top"
  }, null, 8, _hoisted_36), _hoisted_37, _hoisted_38, _hoisted_39, _hoisted_40, _hoisted_41, _hoisted_42, _hoisted_43, _hoisted_44, _hoisted_45, _hoisted_46, _createVNode(_component_router_link, {
    to: {
      name: 'ShareUserAgreements'
    },
    class: "privacy-word"
  }, {
    default: _withCtx(() => [_hoisted_47]),
    _: 1
  }), _hoisted_48, _createVNode(_component_router_link, {
    to: {
      name: 'ShareUserRules'
    },
    class: "privacy-word"
  }, {
    default: _withCtx(() => [_hoisted_49]),
    _: 1
  }), _hoisted_50, _hoisted_51]), _createElementVNode("img", {
    src: $setup.Close,
    class: "close-icon",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.closeTip && $setup.closeTip(...args))
  }, null, 8, _hoisted_52)])) : _createCommentVNode("", true)]);
}